import CryptoJS from 'crypto-js';

const SECRET_KEY = 'justtawk_secure_key_77';
const PREFIX = 'jt_enc_'; // Signature to identify our encrypted data

const originalSetItem = localStorage.setItem;
const originalGetItem = localStorage.getItem;

localStorage.setItem = function (key, value) {
    try {
        if (value === null || value === undefined) {
            originalSetItem.apply(this, [key, value]);
            return;
        }
        // Standardize value to string for encryption
        const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
        const ciphertext = CryptoJS.AES.encrypt(stringValue, SECRET_KEY).toString();
        originalSetItem.apply(this, [key, PREFIX + ciphertext]);
    } catch (e) {
        console.error('Error securing store:', e);
        originalSetItem.apply(this, [key, value]);
    }
};

localStorage.getItem = function (key) {
    try {
        const rawValue = originalGetItem.apply(this, [key]);
        if (!rawValue) return null;

        // Only decrypt if it has our signature
        if (typeof rawValue === 'string' && rawValue.startsWith(PREFIX)) {
            const ciphertext = rawValue.substring(PREFIX.length);
            const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
            const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

            try {
                return JSON.parse(decryptedData);
            } catch {
                return decryptedData; // It was just a string
            }
        }

        return rawValue; // Return legacy plain text or non-JT data
    } catch (e) {
        return originalGetItem.apply(this, [key]);
    }
};
